module.exports = __webpack_public_path__ + "e.no2.9541abe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/e.no2.jpg
// module id = Va3o
// module chunks = 0